import { render, staticRenderFns } from "./RegisteredHome.vue?vue&type=template&id=47a51bbe&scoped=true"
import script from "./RegisteredHome.vue?vue&type=script&lang=js"
export * from "./RegisteredHome.vue?vue&type=script&lang=js"
import style0 from "./RegisteredHome.vue?vue&type=style&index=0&id=47a51bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a51bbe",
  null
  
)

export default component.exports